// extracted by mini-css-extract-plugin
module.exports = {"layout":"styles_layout__1PJ5j","font--phone":"styles_font--phone__2V7jP"};